import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import "../../css/estudiantes.css";
import "../../css/CursosMultiSelect.css";
import academicService from "../../services/academicService";
import DocentesFilter from "./DocentesFilter";
import SelectSearch from "react-select-search";
import moment from "moment";
import collectionsService from "../../services/collectionsService";
import organizacionAcademicaService from "../../services/organizacionAcademicaService";
import utils from '../../utils/generalFunctions';
import types from "../../services/types";

// Variante de JornadaAnioPeriodoNivelCursoAsig sin el combo de Nivel Educativo
// y con el combo de Curso en modo multi-selección (usado para clonar logros
// hacia varios cursos a la vez). No se modifica JornadaAnioPeriodoNivelCursoAsig
// para no afectar las demás pantallas que sí usan el combo de Nivel Educativo.
// Los niveles educativos se siguen cargando internamente (sin mostrarse) para
// poder resolver el evaluationTypeId de cada curso seleccionado.
const JornadaAnioPeriodoCursosMultiAsig = forwardRef((props, ref) => {

    const { callback, properties, ReadOnly } = props;
    const [orgAcademica, sertOrgAcademica] = useState([]);
    const [journeyList, setJourneyList] = useState([]);
    const [schoolYearList, setSchoolYearList] = useState([]);
    const [years, setYears] = useState([]);
    const [educationLevels, setEducationLevels] = useState([]);
    const [coursesList, setCoursesList] = useState([]);
    const [courses, setCourses] = useState([]);
    const [periodos, setPeriodos] = useState([]);
    const [subjectsList, setSubjectsList] = useState([]);
    const filteReference = useRef(null);

    let yearsList = [];
    let allCourses = [];
    const initData = {
        teacherId: '0',
        schoolYearId: '0',
        periodId: '0',
        journeyId: '0',
        courseIds: [],
        schoolSubjectId: '0'
    };
    const [formData, setFormData] = useState(initData);

    useImperativeHandle(ref, () => ({
        setFormValues(data) {
            setFormData(prevState => ({
                ...prevState,
                ...data
            }));
            if (data && data.schoolYearId !== undefined && String(data.schoolYearId) !== '0') {
                LoadPeriodos(data.schoolYearId, false);
            }
        },
        getCursos() {
            return courses;
        },
        getEducationLeves() {
            return educationLevels;
        },
        getSchoolYears() {
            return years;
        },
        getJourneys() {
            return journeyList;
        }
    }));

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
        if (name.includes("schoolYearId")) {
            LoadPeriodos(value);
            LoadAsignaturas(formData.courseIds, value);
        } else if (name.includes("journeyId")) {
            LoadYears(value);
            LoadCourses(value);
        }
    };

    // El CSS compartido de SelectSearch (ReactSelectSearch.css) solo oculta el
    // panel de opciones cuando pierde el foco para los combos de selección
    // única; en modo múltiple queda siempre visible (mismo ajuste manual que
    // usa EstudentListFilter para su combo multi-selección de estudiantes).
    const toggleCoursesOptionsList = (display) => {
        const cmb = document.getElementById((properties && properties.id) ? `cmbCursos-${properties.id}` : "cmbCursos");
        if (cmb) {
            const list = cmb.getElementsByClassName("select-search-select")[0];
            if (list) list.style.display = display;
        }
    };

    const handleCoursesChange = (selectedValues) => {
        const courseIds = Array.isArray(selectedValues)
            ? selectedValues
            : (selectedValues !== undefined && selectedValues !== null ? [selectedValues] : []);
        setFormData(prevState => ({
            ...prevState,
            courseIds
        }));
        LoadAsignaturas(courseIds, formData.schoolYearId);
    };

    useEffect(() => {
        if (callback) {
            callback(formData);
        }
    }, [formData]);

    const LoadTeacherInformation = (teacherId) => {
        let orgTeacher = orgAcademica.filter(o => o.teacherId === teacherId);
        const journeyResp = utils.removeDuplicates(orgTeacher.map((o) => { return { journeyId: o.journeyId, name: o.journeyName } }));
        setJourneyList(journeyResp);
        const journeyId = (journeyResp.length === 1) ? journeyResp[0].journeyId : "";

        yearsList = utils.removeDuplicates(orgTeacher.map((o) => { return { schoolYearId: o.schoolYearId, year: o.schoolYear, journeyId: o.journeyId } }));
        setSchoolYearList(yearsList);
        setYears(yearsList);
        fechtCurrentAnioToTeacher(yearsList);

        const allEducationLevels = utils.removeDuplicates(orgTeacher.map((o) => { return { educationLevelId: o.educationLevelId, name: o.educationLevelName, evaluationTypeId: o.evaluationTypeId } }));
        setEducationLevels(allEducationLevels);

        allCourses = utils.removeDuplicates(orgTeacher.map((o) => { return { courseId: o.courseId, name: o.courseName, journeyId: o.journeyId, educationLevelId: o.educationLevelId, gradeId: o.gradeId } }));
        setCoursesList(allCourses);
        setCourses(allCourses);

        setFormData(prev => ({
            ...prev,
            journeyId: journeyId,
            courseIds: [],
            schoolSubjectId: '0'
        }));
    }

    const LoadYears = (journeyId) => {
        if (journeyId !== "0") {
            if (yearsList.length > 0) {
                const yrs = yearsList.filter((op) => String(op.journeyId) === journeyId);
                setYears(yrs);
            } else if (schoolYearList.length > 0) {
                const yrs = schoolYearList.filter((op) => String(op.journeyId) === journeyId);
                setYears(yrs);
            }
        }
        setFormData(prevState => ({
            ...prevState,
            schoolYearId: '0'
        }));
    };

    // A diferencia de JornadaAnioPeriodoNivelCursoAsig, aquí los cursos solo se
    // acotan por jornada: no hay combo de Nivel Educativo que los siga filtrando.
    const LoadCourses = (journeyId) => {
        const source = (allCourses.length > 0) ? allCourses : coursesList;
        const courseFiltred = (journeyId !== "0") ? source.filter((op) => String(op.journeyId) === journeyId) : source;
        setCourses(courseFiltred);
        setSubjectsList([]);
        setFormData(prevState => ({
            ...prevState,
            courseIds: [],
            schoolSubjectId: '0'
        }));
    };

    // Las asignaturas se calculan como la unión de asignaturas disponibles para
    // todos los cursos seleccionados en el año escolar elegido.
    const LoadAsignaturas = (courseIds, schoolYearId) => {
        if (!courseIds || courseIds.length === 0 || !schoolYearId || String(schoolYearId) === '0') {
            setSubjectsList([]);
            setFormData(prevState => ({ ...prevState, schoolSubjectId: '0' }));
            return;
        }
        const orgTeacher = orgAcademica.filter(o => o.teacherId === formData.teacherId);
        const idsSet = new Set(courseIds.map(id => String(id)));
        const relevant = orgTeacher.filter(o => idsSet.has(String(o.courseId)) && String(o.schoolYearId) === String(schoolYearId));
        const allSubjects = utils.removeDuplicates(relevant.map((o) => { return { schoolSubjectId: o.schoolSubjectId, name: o.schoolSubjectName } }));
        setSubjectsList(allSubjects);
        setFormData(prevState => ({
            ...prevState,
            schoolSubjectId: (allSubjects.length === 1) ? allSubjects[0].schoolSubjectId : '0'
        }));
    };

    const fetchLoadFiltersSchoolYears = async () => {
        try {
            const respOrgAcademica = await organizacionAcademicaService.getAcademicOrganizations();
            sertOrgAcademica(respOrgAcademica);
            cargarInformacionUsuario();
        } catch (error) {
            console.error("Error al obtener listas de formulario:", error);
        }
    };

    const cargarInformacionUsuario = () => {
        const user = utils.getUserInformation();
        if (user) {
            const typeId = Number(user.userTypeId);
            if (typeId === types.userTypes.TEACHER) {
                filteReference.current?.setDocenteByUser(user.userId);
            }
        }
    };

    useEffect(() => {
        fetchLoadFiltersSchoolYears();
        // El panel de opciones de Cursos (multi-selección) arranca visible por
        // defecto salvo que lo ocultemos explícitamente; lo cerramos al montar.
        toggleCoursesOptionsList('none');
    }, []);

    const LoadPeriodos = async (schoolYearId, autoSelect = true) => {
        if (String(schoolYearId) !== '0') {
            const resYear = await academicService.getYearById(schoolYearId);
            if (resYear) {
                const peri = resYear.periods.filter(p => p.isRecuperation === 0 || !p.isRecuperation);
                setPeriodos(peri);
                if (autoSelect) {
                    let selectedP = null;
                    for (let i = 0; i < peri.length; i++) {
                        const p = peri[i];
                        selectedP = p;
                        const today = moment().toDate();
                        const start = moment(p.startDate).toDate();
                        const end = moment(p.endDate).toDate();
                        if ((today >= start) && (today <= end)) {
                            selectedP = p;
                            break;
                        } else if (today <= start) {
                            selectedP = p;
                            break;
                        }
                    }
                    if (selectedP !== null) {
                        setFormData(prevState => ({
                            ...prevState,
                            periodId: selectedP.academicPeriodId
                        }));
                    }
                }
            } else {
                setPeriodos([]);
            }
        } else {
            setPeriodos([]);
        }
    }

    const fechtCurrentAnioToTeacher = async (years) => {
        const parameters = await collectionsService.getParameters();
        const currentAnio = parameters.find((op) => String(op.keyName) === "AnioElectivo");
        if (currentAnio) {
            if (years.find(y => String(y.schoolYearId) === currentAnio.value)) {
                setFormData(prevState => ({
                    ...prevState,
                    schoolYearId: currentAnio.value
                }));
                LoadPeriodos(currentAnio.value);
            } else {
                if (years.length === 1) {
                    const preLoad = years[0].schoolYearId;
                    setFormData(prevState => ({
                        ...prevState,
                        schoolYearId: preLoad
                    }));
                    LoadPeriodos(preLoad);
                } else {
                    setPeriodos([]);
                }
            }
        }
    }

    const clearFiltersArray = () => {
        setJourneyList([]);
        setSchoolYearList([]);
        setYears([]);
        setPeriodos([]);
        setEducationLevels([]);
        setCoursesList([]);
        setCourses([]);
        setSubjectsList([]);
    }

    const handleFilterChange = async (newFilters) => {
        if (String(newFilters.teacherId) === '0') {
            clearFiltersArray();
            setFormData(initData);
        } else {
            setFormData(prev => ({
                ...prev,
                ...newFilters
            }));
            await LoadTeacherInformation(newFilters.teacherId);
        }
    };

    return (
        <>
            <DocentesFilter
                callback={handleFilterChange}
                properties={
                    {
                        className: 'col-md-8 mb-3',
                        id: (properties && properties.id) ? properties.id : undefined,
                    }
                }
                ref={filteReference}
            />

            <div className={(properties && properties.className) ? properties.className : "col-md-2 mb-2"} >
                <label className="form-label">Jornada:</label>
                <select
                    id={(properties && properties.id) ? `cmbJourney-${properties.id}` : "cmbJourney"}
                    className="form-control form-select validarForm "
                    name="journeyId"
                    value={formData.journeyId}
                    onChange={handleChange}
                    disabled={ReadOnly}
                >
                    <option value="0"> {(properties && !properties.filtro) ? 'Seleccione' : 'Todos'}</option>
                    {journeyList.map((option) => (
                        <option key={option.journeyId} value={option.journeyId}>
                            {option.name}
                        </option>
                    ))}
                </select>
            </div>
            <div className={(properties && properties.className) ? properties.className : "col-md-2 mb-2"}>
                <label htmlFor={(properties && properties.id) ? `schoolYearId-${properties.id}` : "schoolYearId"}
                    className="form-label">Año escolar:</label>
                <select className="form-control form-select"
                    id={(properties && properties.id) ? `schoolYearId-${properties.id}` : "schoolYearId"}
                    name="schoolYearId"
                    value={formData.schoolYearId}
                    onChange={handleChange}
                    disabled={ReadOnly}>
                    <option value="0" > {(properties && !properties.filtro) ? 'Seleccione' : 'Todos'}</option>
                    {years.map((schoolYear) => (
                        <option key={schoolYear.schoolYearId} value={schoolYear.schoolYearId} >
                            {schoolYear.year}
                        </option>
                    ))}
                </select>
            </div>
            <div className={(properties && properties.className) ? properties.className : "col-md-2 mb-2"}>
                <label htmlFor={(properties && properties.id) ? `periodId-${properties.id}` : "periodId"}
                    className="form-label">Periodo:</label>
                <select className="form-control form-select"
                    id={(properties && properties.id) ? `periodId-${properties.id}` : "periodId"}
                    name="periodId"
                    value={formData.periodId}
                    onChange={handleChange}
                    disabled={ReadOnly}>
                    <option value="0" > {(properties && !properties.filtro) ? 'Seleccione' : 'Todos'}</option>
                    {periodos.map((periodo) => (
                        <option key={periodo.academicPeriodId} value={periodo.academicPeriodId} >
                            {periodo.periodName}
                        </option>
                    ))}
                </select>
            </div>
            <div className={(properties && properties.className) ? properties.className : "col-md-2 mb-2"}>
                <label htmlFor={(properties && properties.id) ? `cmbCursos-${properties.id}` : "cmbCursos"} className="form-label">Cursos:</label>
                <div className='container-searcher-general cursos-multi-search'>
                    <SelectSearch
                        options={courses.map(c => ({ name: c.name, value: c.courseId }))}
                        id={(properties && properties.id) ? `cmbCursos-${properties.id}` : "cmbCursos"}
                        value={formData.courseIds}
                        multiple
                        search
                        closeOnSelect={false}
                        placeholder="Selecciona uno o varios cursos"
                        onChange={handleCoursesChange}
                        disabled={ReadOnly}
                        onFocus={() => { toggleCoursesOptionsList(''); }}
                        onBlur={() => { toggleCoursesOptionsList('none'); }}
                    />
                </div>
            </div>
            <div className={(properties && properties.className) ? properties.className : "col-md-2 mb-2"}>
                <label htmlFor={(properties && properties.id) ? `schoolSubjectId-${properties.id}` : "schoolSubjectId"}
                    className="form-label">Asignatura:</label>
                <select className="form-control form-select"
                    id={(properties && properties.id) ? `schoolSubjectId-${properties.id}` : "schoolSubjectId"}
                    name="schoolSubjectId"
                    value={formData.schoolSubjectId}
                    onChange={handleChange}
                    disabled={ReadOnly}>
                    <option value="0" > {(properties && !properties.filtro) ? 'Seleccione' : 'Todos'}</option>
                    {subjectsList.map((subject) => (
                        <option key={subject.schoolSubjectId} value={subject.schoolSubjectId} >
                            {subject.name}
                        </option>
                    ))}
                </select>
            </div>
        </>
    );
});

export default JornadaAnioPeriodoCursosMultiAsig;
